function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Text, Layout } from "../../../native";
import Slider from "../../../Slider";
import { StyleSheet } from 'react-native';
import { rangeSpec } from "../../utils";
import { useFormContext } from "../FormContext";

const RangeWidget = ({
  value,
  readonly,
  disabled,
  schema,
  onChange,
  formContext
}) => {
  // @ts-ignore
  const {
    min = 0,
    step = 1,
    max = 100
  } = rangeSpec(schema);
  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Text, _extends({}, mapping.text, {
    style: [mapping.text.style, styles.ends]
  }), min), /*#__PURE__*/React.createElement(Slider, _extends({}, mapping.slider, {
    style: [mapping.slider.style, styles.slider],
    value: value,
    step: step,
    disabled: disabled || readonly,
    minimumValue: min,
    maximumValue: max,
    onValueChange: onChange
  })), /*#__PURE__*/React.createElement(Text, _extends({}, mapping.text, {
    style: [mapping.text.style, styles.ends]
  }), value));
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row'
  },
  ends: {
    fontSize: 14,
    color: 'gray'
  },
  slider: {
    flex: 1,
    marginLeft: 15,
    marginRight: 15,
    height: 40
  }
});
export default RangeWidget;